import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Victory2";

const Victory2 = () => {
  const projectId = 44;
  const title = "Victory Phase 2";

  const mapConfig = {
    minZoom: 10,
    zoom: 11,
    bounds: [
        [61.75, 18.53],
        [61.5, 18.84],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // Links disabled in original
      viewProjectLink={null}
      fillOfferLink={null}
    />
  );
};

export default Victory2;
